import React from 'react';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DokkaPayTitleText from '../DokkaPayTitleText';

import BGImage from './images/BG.svg';

const KYCPendingScreen: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Stack alignItems="center" textAlign="center" maxWidth={500} spacing={3} justifyContent="center" height="100%">
      <img src={BGImage} alt="dokka-pay-image" />
      <DokkaPayTitleText />
      <Typography variant="h4">
        {formatMessage({
          id: 'company.paymentsWorkspace.kycPendingScreen.title',
          defaultMessage: 'KYC verification is in progress.',
        })}
      </Typography>
      <Typography variant="body1">
        {formatMessage({
          id: 'company.paymentsWorkspace.kycPendingScreen.description',
          defaultMessage:
            'Your company has started the KYC process, but only the Payment Owner can complete it. You\'ll be notified once verification is approved.',
        })}
      </Typography>
    </Stack>
  );
};

export default KYCPendingScreen;
